const statusLabels = {
  draft: "Draft",
  pending_review: "New",
  confirmed: "Confirmed",
  in_progress: "Preparing",
  completed: "Completed",
  canceled: "Cancelled",
  refunded: "Refunded",
  new: "New",
  preparing: "Preparing",
  ready: "Ready",
  delivery: "Out for Delivery",
  cancelled: "Cancelled",
};

const statusClasses = {
  draft: "new",
  pending_review: "new",
  confirmed: "ready",
  in_progress: "preparing",
  completed: "completed",
  canceled: "cancelled",
  refunded: "cancelled",
  new: "new",
  preparing: "preparing",
  ready: "ready",
  delivery: "delivery",
  cancelled: "cancelled",
};

function OrderStatusBadge({ status, label }) {
  const visualStatus = statusClasses[status] || status || "new";
  return <span className={["order-status", `order-status--${visualStatus}`].join(" ")}>{label || statusLabels[status] || status}</span>;
}

export default OrderStatusBadge;
